



















































import {
  defineComponent,
  PropType,
  ref,
  computed
} from '~/utils/nuxt3-migration'
import { SmartResultSection } from '~/models/search-bar'
import SmartSearchbarAutocompleteSuggestion from '~/components/shared/classified/search/searchbar/smart-suggestions/SmartSearchbarAutocompleteSuggestion.vue'
import SmartSearchbarActionSuggestion from '~/components/shared/classified/search/searchbar/smart-suggestions/SmartSearchbarActionSuggestion.vue'
import SmartSearchbarClassifiedSuggestion from '~/components/shared/classified/search/searchbar/smart-suggestions/SmartSearchbarClassifiedSuggestion.vue'
import SearchbarSuggestedClassified from '~/components/shared/classified/search/searchbar/suggestions/SearchbarSuggestedClassified.vue'
import CShimmer from '~/components/shared/configurable/shimmer/CShimmer.vue'
import { getRandomNumberBetween } from '~/utils/number'

export default defineComponent({
  components: {
    CShimmer,
    SearchbarSuggestedClassified,
    SmartSearchbarClassifiedSuggestion,
    SmartSearchbarActionSuggestion,
    SmartSearchbarAutocompleteSuggestion
  },
  props: {
    section: {
      type: Object as PropType<SmartResultSection>,
      required: true
    },
    sectionIndex: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const classifiedRefs = ref<
      (InstanceType<typeof SmartSearchbarClassifiedSuggestion> | null)[]
    >([])

    const triggerClassifiedAtIndex = (index: number) => {
      if (classifiedRefs.value[index]) {
        classifiedRefs.value[index].triggerThumbClick(null)
      }
    }

    const entryShimmerHeight = computed(() => {
      switch (props.section.type) {
        case 'classified':
          return '68px'
        case 'action':
          return '40px'
        case 'autocomplete':
        default:
          return '30px'
      }
    })
    return {
      classifiedRefs,
      triggerClassifiedAtIndex,
      entryShimmerHeight,
      getRandomNumberBetween
    }
  }
})
